<template>
  <div class="all">
    <!-- 區塊一 -->
    <section id="section1" class="section1">
      <subNav></subNav>
      <div class="custom-container">
        <div class="page-header" data-aos="zoom-in" data-aos-duration="800">
          <h3 class="title">平面設計</h3>
          <ul class="content">
            <li>特色化名片製作</li>
            <li>DM / EDM</li>
            <li>活動視覺設計</li>
            <li>產品包裝設計</li>
            <li>書冊設計</li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 區塊二 -->
    <section class="section2">
      <div class="custom-container">
        <div class="custom-row">
          <div class="custom-grid">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img"></div>
              <div class="project-text">201811_無極限有限公司_名片</div>
            </div>
          </div>
          <div class="custom-grid">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img"></div>
              <div class="project-text">201810_益銓興業有限公司_名片</div>
            </div>
          </div>
          <div class="custom-grid">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img"></div>
              <div class="project-text">201803_腦容量補習班_名片</div>
            </div>
          </div>
          <div class="custom-grid">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img"></div>
              <div class="project-text">201811_國新數位有限公司_名片</div>
            </div>
          </div>
        </div>
        <div class="more">
              <a href="javascript:;" class="btn rounded-0">MORE</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import subNav from './subNav.vue';
  export default {
    name: 'Service-graphic',
    components: {
      subNav,
    },
    data() {
      return {

      }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/common.scss';
  @import 'src/assets/scss/service/graphic/section1.scss';
  @import 'src/assets/scss/service/graphic/section2.scss';
</style>



// WEBPACK FOOTER //
// src/components/Graphic.vue